<template>
  <div id="app" style="background:#f0f2f5;min-height:100vh;">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp :mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp :mesaj="text1" v-model="snackbar" :color="snackbarkColor"></snackbarcomp>

    <!-- Cari Onay Dialog -->
    <v-dialog v-model="cariDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('Hotel-Payment-Confirmation') }}</v-card-title>
        <v-card-text v-html="paymentConfirmationMessage"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cariDialog = false">{{ $t('cancel_button') }}</v-btn>
          <v-btn color="green darken-1" text @click="confirmCariPayment">{{ $t('Approve') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Kredi Kartı Dialog -->
    <v-dialog v-model="creditCardDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{ $t('Hotel-Credit-Card-Information') }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field :label="$t('Hotel-Card-Holder')" v-model="PaymentForm.CardHolderName" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field :label="$t('Card-Number')" v-model="PaymentForm.CardNumber" required></v-text-field>
              </v-col>
              <v-col cols="6" sm="4">
                <v-text-field :label="$t('Hotel-Card-Month')" v-model="PaymentForm.ExpirationMonth" required></v-text-field>
              </v-col>
              <v-col cols="6" sm="4">
                <v-text-field :label="$t('Hotel-Card-Year')" v-model="PaymentForm.ExpirationYear" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field :label="$t('Hotel-Card-CVC')" v-model="PaymentForm.CVC" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="creditCardDialog = false">{{ $t('cancel_button') }}</v-btn>
          <v-btn color="blue darken-1" text @click="submitCreditCardPayment">{{ $t('Hotel-Pay-By-Card').split(' ')[0] === 'Payer' ? $t('Hotel-Pay-By-Card').substring(5) : 'Öde' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ana İçerik -->
    <div v-show="!loadingvmodel">
      <v-form ref="formHotel" v-model="valid">
        <div style="max-width:90%;margin:0 auto;padding:16px;">

          <!-- Header Kartı -->
          <div class="page-header-card">
            <div>
              <div style="font-size:12px;opacity:0.75;margin-bottom:4px;">{{ $t('Search-Hotel') }} &rsaquo; {{ $t('Hotel-Payment-Confirmation') }}</div>
              <div style="font-size:22px;font-weight:600;">{{ $t('Hotel-Reservation-Details') }}</div>
            </div>
          </div>

          <v-layout row wrap>
            <!-- SOL KOLON: Formlar -->
            <v-flex xs12 md8 pr-2>

              <!-- Otel Bilgileri Kartı -->
              <div class="section-card info-card" v-if="hotelBooking">
                <div class="card-header purple-bar">
                  <div style="display:flex;align-items:center;gap:8px;">
                    <v-icon color="#667eea">hotel</v-icon>
                    <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Hotel-Information') }}</span>
                  </div>
                </div>
                <div class="card-body">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 pr-1>
                      <div style="font-size:14px;color:#6b7280;">{{ $t('Hotel-Name') }}</div>
                      <div style="font-size:18px;font-weight:600;color:#1f2937;margin-top:4px;">{{
                        hotelBooking.HotelName }}</div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <div style="font-size:14px;color:#6b7280;">{{ $t('Hotel-City') }}</div>
                      <div style="font-size:18px;font-weight:600;color:#1f2937;margin-top:4px;">{{ hotelBooking.CityName
                        }}, {{ hotelBooking.Country }}</div>
                    </v-flex>
                    <v-flex xs12 sm6 pr-1 class="mt-3">
                      <div style="font-size:14px;color:#6b7280;">{{ $t('Hotel-Check-In') }}</div>
                      <div style="font-size:18px;font-weight:600;color:#1f2937;margin-top:4px;">{{
                        hotelBooking.StartDate | dateSlice }}</div>
                    </v-flex>
                    <v-flex xs12 sm6 class="mt-3">
                      <div style="font-size:14px;color:#6b7280;">{{ $t('Hotel-Check-Out') }}</div>
                      <div style="font-size:18px;font-weight:600;color:#1f2937;margin-top:4px;">{{ hotelBooking.EndDate
                        | dateSlice }}</div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>

              <!-- Yolcu Kartları Oda Bazında Gruplandırılmış -->
              <div v-for="(group, gIndex) in roomGroups" :key="'room-group-' + group.roomId">
                <div class="room-group-header">
                  <v-icon small color="#667eea" class="mr-1">meeting_room</v-icon>
                  {{ gIndex + 1 }}. {{ $t('Room') }}
                </div>
                <HotelPassengerCard v-for="item in group.items" :key="'pax-' + item.idx" :passenger="item.pax"
                  :index="item.idx" :disabled="passengersLocked" :contactIndex="contactInfo.Index"
                  :genderItems="genderItems" :rules="rules" :checkInDate="hotelBooking && hotelBooking.StartDate"
                  @defaultContact="defaultContact" @changeFirstName="changeFirstName" @changeLastName="changeLastName"
                  @changeEmail="changeEmail" @changePhone="changePhone" @updatePassenger="updatePassenger" />
              </div>

              <!-- İletişim Kartı -->
              <HotelContactCard v-if="hotelBooking" :contact="contactInfo" :rules="rules" />

              <!-- Fatura Kartı -->
              <div class="section-card invoice-card" v-if="hotelBooking">
                <div class="card-header amber-bar">
                  <div style="display:flex;align-items:center;gap:8px;">
                    <v-icon color="#f59e0b">receipt</v-icon>
                    <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Hotel-Billing-Information') }}</span>
                  </div>
                </div>
                <div class="card-body">
                  <caricomp v-model="cariItem" v-bind:zorunlumu="true" :aktifmi="false"></caricomp>
                </div>
              </div>

            </v-flex>

            <!-- SAĞ KOLON: Sidebar -->
            <v-flex xs12 md4>
              <HotelSidebar :hotelBooking="hotelBooking" :footerTotalFare="footerTotalFare"
                :reservationAttempted="reservationAttempted" :loadingvmodel="loadingvmodel"
                @paymentStart="startPayment" />
            </v-flex>
          </v-layout>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import HotelSidebar from "./islem_components/HotelSidebar.vue";
import HotelPassengerCard from "./islem_components/HotelPassengerCard.vue";
import HotelContactCard from "./islem_components/HotelContactCard.vue";
import auth from "@/api/auth.js";
import helpers from "@/components/app/customcomp/helpers.js";
import Airports from "../ucak/airports.js";
import tool from "@/components/app/coper/tools";
import { kaydetRezervasyon } from "./utils/rezervasyonkaydet.js";

export default {
  data() {
    return {
      snackbarkColor: "success",
      valid: true,
      text1: null,
      snackbar: false,
      loadingvmodel: true,
      hotelBooking: null,
      footerTotalFare: 0,
      cariItem: null,
      sayfayetki: { Screen: false, Update: false, Save: false, Delete: false, Status: false, Message: null, islem: 0 },
      rules: {
        required: (v) => !!v || this.$t('Hotel-Required-Field'),
        email: (v) => {
          const p = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return p.test(v) || this.$t('Hotel-Valid-Email');
        },
      },
      passengerList: [],
      genderItems: [
        { value: "Male", text: this.$t('Hotel-Male') },
        { value: "Female", text: this.$t('Hotel-Female') }
      ],
      contactInfo: {
        Name: "",
        LastName: "",
        Phone: "",
        Email: "",
        Index: -1
      },
      makePaymentItem: Airports.makePayment(),
      billingInformationItem: Airports.billingInformation(),
      isContactDefault: -1,
      cariDialog: false,
      creditCardDialog: false,
      paymentInfo: null,
      PaymentForm: {
        CardHolderName: "",
        CardNumber: "",
        ExpirationMonth: "",
        ExpirationYear: "",
        CVC: ""
      },
      paymentProcessInitiated: false,
      passengersLocked: false,
      transactionId: "",
      transactionResponse: "",
      reservationAttempted: false
    };
  },

  computed: {
    roomGroups() {
      const groups = [];
      const map = new Map();
      this.passengerList.forEach((pax, idx) => {
        if (!map.has(pax.RoomId)) {
          map.set(pax.RoomId, { roomId: pax.RoomId, items: [] });
          groups.push(map.get(pax.RoomId));
        }
        map.get(pax.RoomId).items.push({ pax, idx });
      });
      return groups;
    },
    paymentConfirmationMessage() {
      const msg = this.$t('Hotel-Payment-Confirmation-Text');
      return msg.replace('{amount}', `<b>${helpers.moneyformat(this.footerTotalFare)}</b>`);
    }
  },

  methods: {
    getShoppingCart() {
      const bookingParamsStr = window.localStorage.getItem("bookingParams");
      if (!bookingParamsStr) {
        this.text1 = this.$t('Hotel-Session-Not-Found');
        this.snackbar = true;
        this.loadingvmodel = false;
        setTimeout(() => { this.$router.go(-1); }, 2000);
        return;
      }

      const bookingParams = JSON.parse(bookingParamsStr);
      const shopCartID = window.localStorage.getItem("shopCartID");

      if (!shopCartID) {
        this.text1 = this.$t('Hotel-Shopping-Cart-Not-Found');
        this.snackbar = true;
        this.loadingvmodel = false;
        setTimeout(() => { this.$router.go(-1); }, 2000);
        return;
      }

      this.$http.post(auth.BOOKING_API_URL + "GetShoppingCart", {
        SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken },
        ShoppingCartId: shopCartID,
      }).then(
        (response) => {
          if (!response.body.HasError && response.body.ShoppingCart && response.body.ShoppingCart.HotelBookings) {
            this.hotelBooking = response.body.ShoppingCart.HotelBookings[0];
            this.footerTotalFare = this.hotelBooking.ArkmanPrice || this.hotelBooking.ServicePrice || 0;

            // Yolcu bilgilerini doldur
            if (this.hotelBooking.PasengerInfo && Array.isArray(this.hotelBooking.PasengerInfo)) {
              this.hotelBooking.PasengerInfo.forEach((paxInfo) => {
                // Adt'ye göre yolcu sayısı kadar form oluştur
                for (let i = 0; i < paxInfo.Adt; i++) {
                  const passenger = {
                    FirstName: "",
                    LastName: "",
                    Email: "",
                    Phone: "",
                    Gender: "Male",
                    BirthDate: null,
                    RoomId: paxInfo.RoomId,
                    PaxType: 0, // Yetişkin
                  };
                  this.passengerList.push(passenger);
                }
                // Çocuklar için de ek formlar oluştur
                for (let i = 0; i < paxInfo.Child; i++) {
                  const passenger = {
                    FirstName: "",
                    LastName: "",
                    Email: "",
                    Phone: "",
                    Gender: "Male",
                    BirthDate: null,
                    RoomId: paxInfo.RoomId,
                    PaxType: 1, // Çocuk
                    IsChild: true,
                    ExpectedAge: (paxInfo.ChildAge && paxInfo.ChildAge[i] !== undefined) ? parseInt(paxInfo.ChildAge[i], 10) : null
                  };
                  this.passengerList.push(passenger);
                }
              });
            }

            // İletişim bilgilerini doldur
            if (response.body.ShoppingCart.Contact) {
              this.contactInfo = {
                Name: response.body.ShoppingCart.Contact.Name || "",
                LastName: response.body.ShoppingCart.Contact.LastName || "",
                Phone: response.body.ShoppingCart.Contact.Phone || "",
                Email: response.body.ShoppingCart.Contact.Email || ""
              };
            }

            this.loadingvmodel = false;
          } else {
            const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Hotel-Shopping-Cart-Read-Error');
            this.text1 = errorMsg;
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => {
          this.text1 = this.$t('Hotel-Service-Unavailable');
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },

    changePhone(phone) {
      this.contactInfo.Phone = phone;
    },

    changeEmail(email) {
      if (this.passengerList.length === 1) this.contactInfo.Email = email;
    },

    changeLastName(lastName) {
      if (this.passengerList.length === 1) this.contactInfo.LastName = lastName;
    },

    changeFirstName(firstName) {
      if (this.passengerList.length === 1) this.contactInfo.Name = firstName;
    },

    defaultContact(contact, index) {
      console.log("defaultContact called with index:", index, "and contact:", contact);
      if (this.isContactDefault !== index) {
        this.contactInfo.Name = contact.FirstName;
        this.contactInfo.LastName = contact.LastName;
        this.contactInfo.Phone = contact.Phone;
        this.contactInfo.Email = contact.Email;
        this.isContactDefault = index;
      } else {
        this.contactInfo.Name = "";
        this.contactInfo.LastName = "";
        this.contactInfo.Phone = "";
        this.contactInfo.Email = "";
        this.isContactDefault = -1;
      }
    },

    updatePassenger(pax, index) {
      const updatedPax = {
        ...this.passengerList[index],
        ...pax
      };
      this.$set(this.passengerList, index, updatedPax);
    },

    startPayment(paymentInfo) {
      if (!this.$refs.formHotel.validate()) {
        this.text1 = this.$t('Hotel-Fill-Required-Fields');
        this.snackbar = true;
        return;
      }

      if (!this.cariItem) {
        this.text1 = this.$t('Hotel-Select-Billing-Info');
        this.snackbar = true;
        return;
      }

      this.paymentInfo = paymentInfo; // Store payment info

      // If the payment process has already been initiated (BillingSubmit and UpdatePassenger done)
      if (this.paymentProcessInitiated) {
        this.loadingvmodel = false; // Ensure loading is off if we skip initial steps
        if (this.paymentInfo.paymentType === 2) {
          this.creditCardDialog = true;
        } else {
          this.cariDialog = true;
        }
        return; // Skip further processing
      }

      this.loadingvmodel = true;
      const bookingParamsStr = window.localStorage.getItem("bookingParams");
      const bookingParams = JSON.parse(bookingParamsStr);
      const shopCartID = window.localStorage.getItem("shopCartID");

      this.submitBilling(bookingParams, shopCartID, this.paymentInfo);
    },

    submitBilling(bookingParams, shopCartID, paymentInfo) {
      this.billingInformationItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.billingInformationItem.SessionHeader.SessionToken = bookingParams.SessionToken;
      this.billingInformationItem.ShoppingCartId = window.localStorage.getItem("shopCartID");


      this.$http.post(auth.BOOKING_API_URL + "Billing/Submit", this.billingInformationItem, {
        headers: { Authorization: "Bearer " + auth.getAuthHeader() }
      }).then(
        (response) => {
          if (!response.body.HasError) {
            this.updatePassengers(bookingParams, shopCartID, paymentInfo);
          } else {
            const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Hotel-Billing-Save-Error');
            this.text1 = errorMsg;
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => {
          this.text1 = this.$t('Hotel-Billing-Service-Error');
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },

    updatePassengers(bookingParams, shopCartID, paymentInfo) {
      // Eğer kullanıcı bir varsayılan iletişim kişisi seçmediyse, ilk yolcuyu varsayılan yap.
      if (this.isContactDefault === -1 && this.passengerList.length > 0) {
        const firstPassenger = this.passengerList[0];
        this.contactInfo.Name = firstPassenger.FirstName;
        this.contactInfo.LastName = firstPassenger.LastName;
        this.contactInfo.Phone = firstPassenger.Phone;
        this.contactInfo.Email = firstPassenger.Email;
        this.isContactDefault = 0; // İlk yolcuyu varsayılan olarak işaretle
      }

      const passengers = this.passengerList.map((pax, idx) => ({
        PassengerID: idx + 1,
        PaxType: pax.PaxType,
        PaxRoomNo: pax.RoomId || 1,
        ReservationCode: "",
        Name: (pax.FirstName || "").toUpperCase(),
        SurName: (pax.LastName || "").toUpperCase(),
        NationalId: null,
        BirthDate: pax.BirthDate || null,
        CoperPassID: 0,
        Gender: pax.Gender === "Female" ? "1" : "0",
        HesCode: null,
        PaxReferanceId: "da1c5d0c-758c-4d62-9fa2-9169e309c28a",
        Age: 0
      }));

      const updateData = {
        SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken },
        ShoppingCartId: shopCartID,
        HotelName: this.hotelBooking.HotelName || "",
        Message: "",
        Contact: {
          Name: this.contactInfo.Name || "",
          LastName: this.contactInfo.LastName || "",
          Phone: this.contactInfo.Phone || "",
          Email: this.contactInfo.Email || ""
        },
        Passengers: passengers
      };

      this.$http.post(auth.BOOKING_API_URL + "Hotel/UpdatePassenger", updateData, {
        headers: { Authorization: "Bearer " + auth.getAuthHeader() }
      }).then(
        (response) => {
          this.loadingvmodel = false;
          if (!response.body.HasError) {
            this.paymentProcessInitiated = true; // Set flag to true after successful update
            this.passengersLocked = true; // Lock passenger fields after successful update
            if (this.paymentInfo.paymentType === 2) {
              this.creditCardDialog = true;
            } else {
              this.cariDialog = true;
            }
          } else {
            const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Hotel-Passenger-Update-Error');
            this.text1 = errorMsg;
            this.snackbar = true;
          }
        },
        () => {
          this.text1 = this.$t('Hotel-Passenger-Service-Error');
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },

    confirmCariPayment() {
      this.cariDialog = false;
      this.proceedToMakePayment();
    },

    submitCreditCardPayment() {
      this.creditCardDialog = false;
      this.proceedToMakePayment();
    },

    proceedToMakePayment() {
      const bookingParamsStr = window.localStorage.getItem("bookingParams");
      const bookingParams = JSON.parse(bookingParamsStr);
      const shopCartID = window.localStorage.getItem("shopCartID");

      this.loadingvmodel = true;
      this.makePaymentItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.makePaymentItem.SessionHeader.SessionToken = bookingParams.SessionToken;
      this.makePaymentItem.ShoppingCartId = shopCartID;
      this.makePaymentItem.Amount = this.footerTotalFare;
      if (this.paymentInfo.paymentType === 2) {
        this.makePaymentItem.PaymentType = "CreditCardPayment"
        this.PaymentForm.ExpirationYear = this.PaymentForm.ExpirationYear.slice(-2);
        this.makePaymentItem.PaymentForm = this.PaymentForm;
        this.makePaymentItem.PaymentForm.InstallmentId = this.makePaymentItem.ShoppingCartId;
      }
      else {
        this.makePaymentItem.PaymentType = "CurrentPayment";
      }

      this.$http.post(auth.BOOKING_API_URL + "MakePayment", this.makePaymentItem, {
        headers: { Authorization: "Bearer " + auth.getAuthHeader() }
      }).then(
        (response) => {
          if (!response.body.HasError) {
            this.transactionId = response.body.ShoppingCart.HotelBookings[0].TansactionId || "";
            this.transactionResponse = response.body.ShoppingCart.HotelBookings[0].TransactionResponse || "";
            this.makeReservation(bookingParams, shopCartID, response.body.ShoppingCart);
          } else {
            const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Hotel-Payment-Failed');
            this.text1 = errorMsg;
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => {
          this.text1 = this.$t('Hotel-Payment-Service-Error');
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      );
    },

    makeReservation(bookingParams, shopCartID, shoppingCart) {
      this.reservationAttempted = true;
      const hotelBooking = shoppingCart.HotelBookings[0];
      const reservationData = {
        SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken },
        ServiceHotelID: hotelBooking.ServiceHotelID,
        ArkmanHotelId: hotelBooking.ArkmanHotelID,
        ReservationType: hotelBooking.ReservationType || "Confirm",
        ReservationCode: "",
        Name: this.contactInfo.Name || "",
        SurName: this.contactInfo.LastName || "",
        Mail: this.contactInfo.Email || "",
        Address: hotelBooking.Address || "",
        City: hotelBooking.CityName || "",
        Country: hotelBooking.Country || "",
        Phone: this.contactInfo.Phone || "",
        ServicePrice: hotelBooking.ServicePrice || 0,
        CurrencyType: hotelBooking.CurrencyType || "TRY",
        Message: "",
        StartDate: hotelBooking.StartDate ? hotelBooking.StartDate.substring(0, 10) : "",
        EndDate: hotelBooking.EndDate ? hotelBooking.EndDate.substring(0, 10) : "",
        ArkmanPrice: hotelBooking.ArkmanPrice || 0,
        CurrencyCode: this.cariItem,
        Passengers: this.passengerList.map((pax, idx) => ({
          PassengerID: idx + 1,
          PaxType: pax.PaxType,
          PaxRoomNo: pax.RoomId || 1,
          ReservationCode: "",
          Name: (pax.FirstName || "").toUpperCase(),
          SurName: (pax.LastName || "").toUpperCase(),
          NationalId: pax.NationalId || null,
          BirthDate: pax.BirthDate ? pax.BirthDate.substring(0, 10) : "",
          CoperPassID: 0,
          Gender: pax.Gender === "Female" ? "1" : "0",
          HesCode: "",
          PaxReferanceId: "da1c5d0c-758c-4d62-9fa2-9169e309c28a",
          Age: 0
        })),
        LogInput: { UserID: 1, CustomerID: 1 },
        OfferId: hotelBooking.OfferId || "",
        RateId: hotelBooking.RateId || null,
        ShoppingCartId: shopCartID,
        TransactionId: this.transactionId,
        TransactionResponse: this.transactionResponse,
        PaymentOption: null
      };

      this.$http.post(auth.BOOKING_API_URL + "Hotel/MakeReservation", reservationData, {
        headers: { Authorization: "Bearer " + auth.getAuthHeader() }
      }).then(
        (response) => {
          if (!response.body.HasError && response.body.Status) {
            this.$http.post(auth.BOOKING_API_URL + "GetShoppingCart", {
              SessionHeader: { SessionId: bookingParams.SessionId, SessionToken: bookingParams.SessionToken },
              ShoppingCartId: shopCartID
            }).then(
              async (cartResponse) => {
                if (!cartResponse.body.HasError && cartResponse.body.ShoppingCart) {
                  // ShoppingCart -> Rezervasyon dönüşümü + otel/oda tipi/tur operatörü
                  // kontrolü (yoksa otomatik ekleme) + RezervasyonKaydet çağrısı, tek fonksiyonda.
                  const sonuc = await kaydetRezervasyon(this, cartResponse.body, {
                    cariKod: this.cariItem
                  });
                  this.text1 = "Rezervasyon başarıyla tamamlandı!";
                  this.snackbar = true;
                  this.passengersLocked = true;
                  this.loadingvmodel = false;
                  if (!sonuc.basarili) {
                    // Hotel/MakeReservation (asıl otel rezervasyonu) zaten tamamlandığı için burada
                    // akışı durdurmuyoruz; sadece Coper tarafı kaydının başarısız olduğunu logluyoruz.
                    // İsterseniz burada this.text1/this.snackbar ile ayrı bir uyarı da gösterebilirsiniz.
                    console.error("Coper RezervasyonKaydet başarısız:", sonuc.hata);
                  }
                }
              },
              () => { }
            );


          } else {
            const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Hotel-Reservation-Create-Error');
            this.text1 = errorMsg;
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        },
        () => {
          this.text1 = this.$t('Hotel-Reservation-Service-Error');
          this.snackbar = true;
        }
      );
    }
  },

  filters: {
    moneyformat(m) { return helpers.moneyformat(m); },
    dateSlice(val) { return val ? val.substring(0, 10) : ""; },
  },

  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    caricomp,
    HotelSidebar,
    HotelPassengerCard,
    HotelContactCard
  },

  mounted() {
    this.loadingvmodel = true;
    //this.sayfayetki = helpers.pageScreenAuth(this.$route.name);



    this.getShoppingCart();
  },
};
</script>

<style scoped>
/* Header */
.page-header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 20px 24px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

/* Cards */
.section-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 3px solid transparent;
}

.card-header.purple-bar {
  border-top-color: #667eea;
  background: #fafafa;
}

.card-header.green-bar {
  border-top-color: #10b981;
  background: #fafafa;
}

.card-header.amber-bar {
  border-top-color: #f59e0b;
  background: #fafafa;
}

.card-body {
  padding: 14px 16px 4px;
}

.room-group-header {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  padding: 14px 0;
  margin-top: 8px;
  margin-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
}
</style>